import React from "react";
import { X, Image as ImageIcon, Loader2 } from "lucide-react";
import { adminApi } from "../lib/api";

export default function ProofViewerModal({ bookingId, onClose }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    adminApi().get(`/admin/bookings/${bookingId}/proof`)
      .then(({ data }) => setData(data))
      .catch(() => setData({ photos: [] }))
      .finally(() => setLoading(false));
  }, [bookingId]);

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" data-testid="proof-modal">
      <div className="bg-white max-w-3xl w-full max-h-[92vh] overflow-y-auto">
        <div className="bg-brand-dark text-white px-5 py-4 flex items-center justify-between sticky top-0">
          <div>
            <div className="kicker text-brand-red">Bevis-billeder</div>
            <div className="font-display font-bold text-lg mt-1">{data?.booking_number || "..."}</div>
            {data?.delivered_at && (
              <div className="text-xs text-white/60 mt-0.5">Leveret {new Date(data.delivered_at).toLocaleString("da-DK")}</div>
            )}
          </div>
          <button onClick={onClose} data-testid="close-proof" className="w-9 h-9 flex items-center justify-center hover:bg-white/10"><X size={18} /></button>
        </div>
        <div className="p-5">
          {loading && <div className="flex justify-center py-12"><Loader2 className="animate-spin text-brand-red" size={28} /></div>}
          {!loading && (!data?.photos || data.photos.length === 0) && (
            <div className="text-center py-12 text-brand-text2">
              <ImageIcon size={36} className="mx-auto mb-3 text-brand-text2/50" />
              <div>Ingen bevisbilleder for denne booking</div>
            </div>
          )}
          {!loading && data?.photos?.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="proof-grid">
              {data.photos.map((p, i) => (
                <a key={p.uploaded_at || p.label || i} href={p.data} target="_blank" rel="noreferrer" className="block border border-brand">
                  <img src={p.data} alt={p.label} className="w-full aspect-[4/3] object-cover" />
                  <div className="p-3 text-sm">
                    <div className="font-semibold text-brand-dark">{p.label}</div>
                    <div className="text-xs text-brand-text2 mt-0.5">
                      {p.driver_name} · {new Date(p.uploaded_at).toLocaleString("da-DK")}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
